import axios from "axios";
import { getConfiguredHost, getServiceHost, USE_PROD } from "./runtimeHost";

export { USE_PROD };

export let BASE_URL = USE_PROD
  ? "https://" + getServiceHost() + "/api/v1/"
  : "http://" + getConfiguredHost() + ":3002/api/v1/";

export const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Expires: "0",
  },
  withCredentials: true,
  timeout: process.env.NODE_ENV === "production" ? 10000 : 10000000,
});

export const puzzleApi = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Expires: "0",
  },
  withCredentials: true,
  timeout: process.env.NODE_ENV === "production" ? 10000 : 10000000,
});
